import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { CampaignRequestDto } from '../dtos/campaign-request.dto';
import { CampaignResponseDto } from '../dtos/campaign-response.dto';
import { CampaignRequestModel } from '../models/campaign-request.model';
import { CampaignResponseModel } from '../models/campaign-response.model';
import {
  mapCampaignRequestModelToCampaignRequestDto,
  mapCampaignResponseDtoToCampaignResponseModel,
} from '../utils/mapping/mapping.util';

export const updateCampaign: AsyncThunk<
  CampaignResponseModel,
  CampaignRequestModel,
  Record<string, unknown>
> = withMandant<CampaignRequestModel, CampaignResponseModel>(
  Endpoints.CAMPAIGN_BY_CAMPAIGN_ID,
  'campaigns/update-campaign',
  async ({ args, endpoint }) => {
    const url = createPathParams<'campaignId'>(endpoint, {
      campaignId: args.id,
    });

    const requestDto: CampaignRequestDto =
      mapCampaignRequestModelToCampaignRequestDto(args);

    const { data }: AxiosResponse<CampaignResponseDto> =
      await axiosInstance.put(url, requestDto);

    return mapCampaignResponseDtoToCampaignResponseModel(data);
  }
);
